export function dasherize(str: string): string {
  const STRING_DECAMELIZE_REGEXP = (/([a-z\d])([A-Z])/g);
  const STRING_DASHERIZE_REGEXP = (/[ _]/g);
  return str.replace(STRING_DECAMELIZE_REGEXP, '$1_$2')
    .replace(STRING_DASHERIZE_REGEXP, '-')
    .toLowerCase();
}
